module.exports = __webpack_public_path__ + "static/img/pscl.c9cd995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pscl.png
// module id = TDeu
// module chunks = 0